<!--  -->
<template>
  <div>
    <el-form label-position="right" label-width="110px" :model="form">
      <el-form-item label="群名称">
        <el-input v-model="form.chat_name" placeholder="请输入群名称" />
      </el-form-item>
      <el-form-item label="企业">
        <el-tag v-if="form.corp_id!=''" style="margin-right:10px">{{ name }} ({{ form.corp_id }}) </el-tag>
        <el-button type="primary" size="mini" @click="choose">选择企业</el-button>
      </el-form-item>
      <el-form-item label="企业员工">
        <el-tag v-if="form.corp_name!==''" style="margin-right:10px">{{ form.corp_name }}({{ form.corp_userid }})</el-tag>
        <el-button :disabled="form.corp_id===''" type="primary" size="mini" @click="chorwe">选择企业员工</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumbit">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="请选择企业"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :destroy-on-close="true"
      width="60%"
    >
      <enterprise @callback="callback" />
    </el-dialog>
    <el-dialog
      title="绑定员工"
      :visible.sync="dialogVisibler"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="50%"
    >
      <spWorkChoose ref="bandstaffview" @spWork="spWork" />
    </el-dialog>
  </div>
</template>

<script>
import enterprise from '../../behavioralsource/components/enterprise.vue'
// import bandstaff from '../../behavioralsource/components/bandstaff.vue'
import spWorkChoose from '../../behavioralsource/components/spWorkChoose.vue'
import { createChat } from '@/api/officialaccount.js'
export default {
  components: { enterprise, spWorkChoose },
  data() {
    return {
      name: '',
      form: {
        corp_id: '',
        corp_userid: '',
        corp_name: '',
        chat_name: ''
      },
      dialogVisible: false,
      dialogVisibler: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    choose() {
      this.dialogVisible = true
    },
    chorwe() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.open(this.form.corp_id)
      })
    },
    callback(item) {
      // console.log(item)
      this.dialogVisible = false
      this.name = item.corp_name
      this.form.corp_id = item.corp_id
      this.form.corp_userid = ''
      this.form.corp_name = ''
    },
    spWork(item) {
      console.log(item)
      this.dialogVisibler = false
      this.form.corp_name = item.name
      this.form.corp_userid = item.employee_no
    },
    async sumbit() {
      if (this.form.chat_name === '') {
        this.$message.error('请输入群名称')
        return
      }
      if (this.form.corp_userid === '') {
        this.$message.error('请选择企业员工')
        return
      }
      const data = await createChat({
        employee_no: this.form.corp_userid,
        chat_name: this.form.chat_name
      })
      console.log('data', data)
      this.$emit('updata')
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
